import { useEffect, useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import EmployeeFile from '../components/EmployeeFile';

// Staff-side wrapper around the shared <EmployeeFile> component.
// Fetches the current user's unified file and hands it to the renderer.

export default function MyFilePage() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.get('/my/file')
      .then(({ data }) => setData(data))
      .catch((err) => toast.error(err.response?.data?.error || 'Could not load your file.'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500" />
      </div>
    );
  }

  return (
    <EmployeeFile
      data={data}
      canUpload
      uploadTargetId={user?.id}
      // Self-upload via the per-row Upload buttons. Backend uses the
      // role hierarchy to decide auto-verify: teacher/admin self
      // uploads stay 'submitted' until a higher-tier verifies. Reusing
      // the adminManageUserId prop keeps one code path; the name is a
      // legacy artifact — for self this just enables the inline upload
      // affordance, no admin powers granted.
      adminManageUserId={user?.id}
      onUploaded={load}
    />
  );
}
